/* @flow */

import React, { useContext } from "react";
import { useData } from "crustate/react";
import { AnalyticsContext } from "@crossroads/analytics";
import CustomerServiceLink from "../CustomerServiceLink";
import ProductCard from "components/ProductCard";
import { quote as quoteQuery } from "queries";
import { useClient } from "entrypoint/shared";

import { QuoteData } from "data";
import { setQuoteDiscountCode, removeQuoteDiscountCode } from "state/quote";
import { CheckoutCart } from "@crossroads/shop-views";
import useFormat from "helpers/use-format";

const Cart = (): React$Node => {
  const quote = useData(QuoteData);
  const gaContext = useContext(AnalyticsContext);
  const { formatPrice } = useFormat();

  if (!quote.data) {
    return null;
  }

  return (
    <CheckoutCart
      analytics={{ context: gaContext, hasAlternativeContext: false }}
      QuoteData={QuoteData}
      formatPrice={formatPrice}
      setQuoteDiscountCode={setQuoteDiscountCode}
      removeQuoteDiscountCode={removeQuoteDiscountCode}
      quoteQuery={quoteQuery}
      useClient={useClient}
      BtmColSecondaryField={<CustomerServiceLink />}
      ProductCardComponent={ProductCard}
    />
  );
};

export default Cart;
